





















import {Component, Vue} from 'vue-property-decorator';
import {signOut} from "@/helpers/auth";
import {mapGetters} from "vuex";

@Component({computed: mapGetters(['isLimited'])})
export default class Limited extends Vue {

  isLimited!: string;

  mounted(): void {
    if (!this.isLimited) {
      this.$router.replace('/');
    }
  }

  triggerDisconnect(): void {
    signOut()
      .then(() => {
        this.$router.replace('/login')
      })
  }
}
